import React from 'react';
import FooterContent from './FooterContent';
import './Footer.css';

/** Static site footer for the landing page only. */
const Footer = () => (
  <footer className="app-footer app-footer--landing">
    <div className="footer-container">
      <FooterContent variant="bar" isExpanded />
    </div>
  </footer>
);

export default Footer;
